import { get } from 'lodash'
import { required, email, requiredPhone, phone } from 'utils/validation'
import { maxLength } from '../../utils/validation'

export default function(values) {
  return {
    firstName: required(get(values, 'firstName')),
    lastName: required(get(values, 'lastName')),
    email: required(get(values, 'email')) || email(get(values, 'email')),
    phoneNumber: requiredPhone(get(values, 'phoneNumber')) || phone(get(values, 'phoneNumber')),
    relationship: required(get(values, 'relationship')),
    addressLine1: required(get(values, 'addressLine1')),
    addressCity: required(get(values, 'addressCity')),
    // addressStateOrProvince: required(get(values, 'addressStateOrProvince')),
    addressZipCode: required(get(values, 'addressZipCode')) || maxLength(20)(get(values, 'addressZipCode'))
  }
}
